import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { intlMessageShape, linkShape } from '@jutro/prop-types';
import { isIntlShape } from '@jutro/locale';
import { Popover } from '../Popover/Popover';
import { PopoverContainer } from '../PopoverContainer/PopoverContainer';
import styles from "./HelpPopover.module.css";
import { messages } from './HelpPopover.messages';
var helpPopoverPropTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  title: intlMessageShape,
  footerLink: PropTypes.oneOfType([intlMessageShape, linkShape]),
  renderTrigger: PropTypes.func.isRequired
};
export var HelpPopover = function HelpPopover(_ref) {
  var id = _ref.id,
      title = _ref.title,
      footerLink = _ref.footerLink,
      renderTrigger = _ref.renderTrigger,
      popoverProps = _objectWithoutProperties(_ref, ["id", "title", "footerLink", "renderTrigger"]);

  footerLink = typeof footerLink === 'string' || isIntlShape(footerLink) ? {
    label: messages.viewAll,
    href: footerLink
  } : footerLink;
  return React.createElement(Popover, {
    id: id,
    renderTrigger: renderTrigger,
    className: styles.HelpPopover,
    isFlipEnabled: false
  }, React.createElement(PopoverContainer, _extends({
    title: title,
    footerLink: footerLink,
    className: styles.popoverContainer,
    internalClassNames: {
      body: styles.content,
      footer: styles.footer
    }
  }, popoverProps)));
};
HelpPopover.propTypes = helpPopoverPropTypes;
HelpPopover.defaultProps = _objectSpread({}, Popover.defaultProps, {
  title: messages.title
});
HelpPopover.__docgenInfo = {
  componentName: "HelpPopover",
  packageName: "@jutro/components",
  description: "",
  displayName: "HelpPopover",
  methods: [],
  actualName: "HelpPopover",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify this component."
    },
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: "Help popover content"
    },
    title: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Notification popover title",
      defaultValue: {
        value: "messages.title",
        computed: true
      }
    },
    footerLink: {
      type: {
        name: "union",
        value: [{
          name: "union",
          value: [{
            name: "string"
          }, {
            name: "shape",
            value: {
              id: {
                name: "string",
                required: false
              },
              defaultMessage: {
                name: "string",
                required: false
              },
              args: {
                name: "shape",
                value: {},
                required: false
              }
            }
          }]
        }, {
          name: "shape",
          value: {
            label: {
              name: "custom",
              raw: "intlMessageShape.isRequired",
              required: true
            },
            onClick: {
              name: "func",
              required: false
            },
            href: {
              name: "custom",
              raw: "intlMessageShape",
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Description for footer link"
    },
    renderTrigger: {
      type: {
        name: "func"
      },
      required: true,
      description: "Function to render trigger element"
    }
  }
};